var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{staticClass:"flex relative filters-form"},[(_setup.tab)?_c('input',{attrs:{"type":"hidden","name":"tab"},domProps:{"value":_setup.tab}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }